export default __webpack_public_path__ + "static/media/biote_lapis2.567b647b.png";